app.config(['$translateProvider', function ($translateProvider) {
if (localStorage.getItem("NG_TRANSLATE_LANG_KEY") && localStorage.getItem("NG_TRANSLATE_LANG_KEY") == "null") {localStorage.removeItem("NG_TRANSLATE_LANG_KEY");}$translateProvider.translations('th', {
	Appointment:"นัดหมาย",
	DR24_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	Gender:"เพศ",
	SerAbout:"ทีมแพทย์",
	DR07_Language:"อังกฤษ, ไทย",
	DR12_Spine_surgery:"",
	Our_Team:"ทีมแพทย์",
	ks1996_1998:"2539-2541",
	about_us:"เกี่ยวกับเรา",
	DR10_Language:"อังกฤษ, ไทย",
	tel:"เบอร์ติดต่อ:",
	Vistion:"วิสัยทัศน์ & พันธกิจ",
	knowledge:"ความรู้สุขภาพ",
	ngamwongwan:"งามวงศ์วาน",
	DR11_Special_Clinical_Interest_03:"มะเร็งวิทยาของกระดูกสันหลัง",
	Special_Interests:"แขนงที่สนใจเป็นพิเศษ",
	DR11_Special_Clinical_Interest_02:"การผ่าตัดแก้ไขการผิดรูปของกระดูกสันหลัง",
	DR11_Special_Clinical_Interest_01:"การผ่าตัดกระดูกสันหลังชนิดแผลเล็ก",
	packages:"แพ็กเกจ",
	DR28_Lan:"อังกฤษ, ไทย",
	Related:"ที่เกี่ยวข้อง",
	Verify_Account:"ยืนยันบัญชีผู้ใช้งาน",
	Watch_more:"ดูเพิ่มเติม",
	DR19_Spec:"สาขาประสาทศัลยศาสตร์",
	out_team_concept:"แนวคิด",
	C2003:"2544",
	DR21_Lan:"อังกฤษ, ไทย",
	DR24_kku:"มหาวิทยาลัยขอนแก่น",
	find_hospital:"โรงพยาบาล",
	nav_complete:"สำเร็จ",
	close:"ปิด",
	C2016:"2549",
	C2014:"2557",
	address:"ที่อยู่:",
	affiliated_hospitals:"โรงพยาบาลในเครือข่าย",
	DR07_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	nav_sentEmail:"กรูณาตรวจสอบอีเมล",
	Register:"ลงทะเบียน",
	desVideo:"หมายเหตุ : อุปกรณ์และเครื่องมือที่ใช้อาจต่างจากในภาพขึ้นอยู่กับดุลยพินิจของแพทย์",
	DR20_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	register:"ลงทะเบียน",
	DR16_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	HomeASCAKC:"หน้าแรก ASC โรงพยาบาลเอกชล",
	Email:"อีเมล์",
	DR19_Lan:"อังกฤษ, ไทย",
	oldequlnew:"รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านปัจจุบัน",
	HomeASC_ASC:"หน้าแรก ASC",
	contact:"ติดต่อเรา",
	Procedure:"หัตถการ",
	DR27_Lan:"อังกฤษ, ไทย",
	Resend_code:"ส่งรหัสอีกครั้ง",
	SymptomsLink:"อาการของผู้ป่วย",
	preferred_date:"เลือกวันที่ต้องการทำนัดหมาย",
	DR09_Board_Certifications:"วว.(ประสาทศัลยศาสตร์)",
	DR19_mu:"มหาวิทยาลัยมหิดล",
	success:"สำเร็จแล้ว",
	Symptoms:"อาการ",
	Reset_your_password:"ตั้งค่ารหัสผ่าน",
	DR22_Lan:"อังกฤษ, ไทย",
	back:"กลับ",
	warning_emailpass:"กรุณากรอกอีเมลหรือรหัสผ่าน",
	content9:"การฉีดยาสเตรียรอยด์เข้าโพรงประสาท",
	duration:"ระยะทาง",
	Language:"ภาษา",
	DR08_Medical_Faculty:"ปริญญาแพทยศาสตรบัณฑิต",
	New_Password:"รหัสผ่านใหม่",
	Condition:"ภาวะโรค",
	Submitted:"เรียบร้อย",
	special_clinical:"แขนงที่ฝึกฝนเป็นพิเศษ / สนใจเป็นพิเศษ",
	Fellowship:"การศึกษาหลังปริญญา",
	Appointment_date:"วันที่ทำการนัดหมาย",
	DR37_Lan:"อังกฤษ, ไทย",
	HomeAKC_AKC:"หน้าแรก AHC",
	DR11_Medical_Faculty:"แพทยศาสตรบัณฑิต (พ.บ.)",
	Review_Appointment_Detail:"ตรวจสอบรายละเอียดการนัดหมาย",
	DR22_CU:"จุฬาลงกรณ์มหาวิทยาลัย",
	home:"หน้าแรก",
	content8:"การผ่าตัดกระดูกสันหลัง",
	content7:"การผ่าตัดเชื่อมกระดูกสันหลังระดับเอว",
	content6:"โรคหมอนรองกระดูกเคลื่อน",
	content5:"อาการปวดหลัง",
	Follow_Us:"ติดตามเรา",
	content4:"การผ่าตัดเปลี่ยนหมอนรองกระดูกคอเทียม",
	DR11_Board_Certifications_01:"วุฒิบัตรฯ สาขาออร์โธปิดิกส์ (วว. ออร์โธปิดิกส์)",
	Special_Trainings:"แขนงที่ฝึกฝนเป็นพิเศษ",
	content3:"การผ่าตัดเชื่อมข้อกระดูกต้นคอจากทางด้านหน้า",
	DR22_Med:" แพทยศาสตรบัณฑิต",
	DR27_med:"แพทยศาสตรบัณฑิต, คณะแพทยศาสตร์ศิริราชพยาบาล,",
	DR11_Board_Certifications_02:"คณะแพทยศาสตร์ มหาวิทยาลัยขอนแก่น",
	content2:"การผ่าตัดกระดูกสันหลังผ่านกล้องเอ็นโดสโคป",
	content1:"อาการปวดคอร้าวลงแขน",
	DR12_Special_Clinical_Interest_02:"ผ่าตัดกระดูกสันหลังและไขสันหลัง",
	DR15_Spec:"วิสัญญีวิทยา-อนุสาขาเวชศาสตร์ความปวด",
	DR07_Board_Certifications:"สาขาศัลยศาสตร์ออร์โธปิดิกส์, ประเทศไทย",
	articles:"บทความและกิจกรรม",
	DR38_name:"นพ. ทวีชัย จันทร์เพ็ญ",
	Board_Certi:"วุฒิบัตร",
	Appointment_Details:"รายละเอียดการนัดหมาย",
	DR18_Lan:"อังกฤษ, ไทย",
	education:"การศึกษา",
	Birthday:"วันเกิด",
	DR25_Spec:"วิสัญญีวิทยา-อนุสาขาเวชศาสตร์ความปวด",
	DR38_lan:"อังกฤษ,ไทย",
	Surgery:"ผ่าตัดรักษา",
	DR25_rama:"รพ.รามาธิบดี",
	desLogin:"ยังไม่มีบัญชีใช่ไหม กรุณา",
	Current_Password:"รหัสผ่านปัจจุบัน",
	DR15_Rama:"",
	Academic_Activity:"กิจกรรมทางวิชาการ",
	Position:"ตำแหน่ง",
	DR36_name:"นพ. ปวินท์ เกษมพิพัฒน์ชัย",
	HomeAKC_Hospital:"ศูนย์กระดูกสันหลัง โรงพยาบาลเอกชล",
	Affiliated_Hospitals:"โรงพยาบาลในเครือ",
	DR19_med:"แพทยศาสตรบัณฑิต คณะแพทย์ศาสตร์",
	AD2010:"2553",
	AD2011:"2554",
	AD2012:"2556",
	AD2014:"2557",
	WelcometoSpineBumrungrad:"ยินดีต้อนรับสู่เครือข่ายกระดูกสันหลังบำรุงราษฎร์",
	AD2016:"2559",
	save:"บันทึก",
	AD2018:"2561",
	Confirm:"ยืนยัน",
	AD2019:"2562",
	user_profile:"ประวัติผู้ใช้",
	DR12_Medical_Faculty:"แพทยศาสตรบัณฑิต",
	login:"เข้าสู่ระบบ",
	nav_checkEmail:"",
	DR31_Lan:"อังกฤษ, ไทย",
	DR23_Lan:"อังกฤษ, ไทย",
	dr11_2019:"2562",
	dr11_2016:"2559",
	KnowledgeLink:"ความรู้",
	Symptom:"อาการ",
	DR07_Fellowships:"Spine, โรงพยาบาลรามาธิบดี, มหาวิทยาลัยมหิดล, ตำแหน่งทางวิชาการ: รองศาสตราจารย์, โรงพยาบาลรามาธิบดี, มหาวิทยาลัยมหิดล",
	AD2020:"2563",
	Full_name:"ชื่อ - สกุล",
	nav_surgery:"การผ่าตัดรักษา",
	Doctor_name:"ชื่อแพทย์",
	specialists:"ผู้เชี่ยวชาญ",
	Nationality:"สัญชาติ",
	DR29_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	ForgotPass:"ลืมรหัสผ่าน",
	Find_Treatment:"การรักษา",
	chonburi:"ชลบุรี",
	DR32_Spec:"อังกฤษ, ไทย",
	DR13_Medical_School:" โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดล ",
	Appointment_request_submitted:"คำขอทำการนัดหมายถูกส่งเรียบร้อยเเล้ว",
	DR26_Spec_interest:"แขนงที่ฝึกฝนเป็นพิเศษ/ สนใจเป็นพิเศษ",
	DR11_Specialties:"ศัลยศาสตร์กระดูกและข้อ",
	Fellowships:"การศึกษาหลังปริญญา",
	mediical_school:"ปริญญาบัตรและสถาบันการศึกษา",
	Reset:"แก้ไข",
	DR17_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	DR22_CU_non_t:"",
	DR09_Language:"เยอรมัน, อังกฤษ, ไทย",
	AD2003:"2546",
	AD2006:"2549",
	AD2007:"2550",
	ks1993:"2536",
	AD2008:"2551",
	City:"จังหวัด",
	ks1998:"2541",
	DR17_Lan:"อังกฤษ, ไทย",
	DR26_Name:"รศ.พญ. จอมใจ วิจิตรานนท์",
	DR24_med:"แพทยศาสตรบัณฑิต",
	accomplisment:"ผลงาน",
	DR12_Accomplishment_02:"การใช้ค่าเฉลี่ยของ apparent diffusion coefficient จากเครื่องเอ็มอาร์ไอในการคาดคะเนความเหนียวของเนื้องอกเยื่อหุ้มสมอง",
	DR27_Spec:"ประสาทศัลยศาสตร์",
	Get_start:"เริ่มใช้งาน",
	DR25_fellow:"อนุสาขาระงับปวด ",
	DR22_Spec:"ประสาทศัลยศาสตร์",
	DR08_Board_Certifications:"วุฒิบัตร สาขาออร์โธปิดิกส์ ",
	home_bsn:"เครือข่ายกระดูกสันหลังบำรุงราษฎร์",
	DR12_Accomplishment_01:"การศึกษากายวิภาคของเอ็นยึดปลายล่างไขสันหลัง และเยื่อหุ้มไขสันหลังในประชากรไทย",
	DR24_Lan:"อังกฤษ, ไทย",
	DR37_Spec:"ประสาทศัลยศาสตร์",
	HomeASCPrinc:"หน้าแรก ASC โรงพยาบาลพริ๊นซ์",
	Accomplishment:"ผลงาน",
	live_your2:"กับ Absolute Spine Care",
	live_your1:"ใช้ชีวิตที่เต็มเปี่ยม",
	DR11_Language:"อังกฤษ, ไทย",
	Find:" ค้นหา",
	Completed:"เสร็จ",
	DR08_Specialties:"ศัลยศาสตร์กระดูกและข้อ",
	DR15_Phramong:"",
	DR13_Special_Clinical_Interest_02:"ผ่าตัดกระดูกสันหลังและไขสันหลัง",
	position_in_associations:"ตำแหน่ง (ในสมาคมต่างๆ)",
	Phone_number:"เบอร์โทรศัพท์",
	Make_Appointment:"นัดหมายแพทย์",
	welcome:"ยินดีต้อนรับ",
	fname:"นพ. กิตติ",
	timline2020:"2563 - ปัจจุบัน",
	DR32_Lan:"อังกฤษ, ไทย",
	DR25_med:"แพทยศาสตรบัณฑิต ",
	namefull:"นพ. กิตติ อรุณจรัสธรรม",
	DR11_Medical_School:"คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล",
	DR38_spec:"ประสาทศัลยศาสตร์",
	DR15_MU:"",
	Close:"close",
	DR13_Special_Clinical_Interest_01:"",
	DR16_Lan:"อังกฤษ, ไทย",
	DR12_Medical_School:"จุฬาลงกรณ์มหาวิทยาลัย",
	DR16_position:"ศาสตร์ มหาวิทยาลัยบูรพา",
	Forgot_password:"ลืมรหัสผ่าน",
	readMore:"อ่านเพิ่มเติม",
	Im_sick:"ฉันป่วย",
	DR10_Fellowships_02:"AOSpine fellow at Queen’s Medical Centre, Nottingham, ประเทศอังกฤษ",
	DR14_Spec:"ศัลยศาสตร์กระดูกและข้อ",
	DR13_Board_Certifications_01:"ประสาทศัลยศาสตร์ ",
	DR10_Fellowships_01_1:"Full-Endoscopic spine surgery",
	DR10_Fellowships_01_2:" with Dr. Sebastian Ruetten at St. Anna-Hospital Herne, Herne, ประเทศเยอรมัน",
	email:"อีเมล:",
	DR15_DoctorofMedicine:"แพทยศาสตรบัณฑิต",
	DR25_Diploma:"วุฒิบัตรวิสัญญีวิทยา ",
	network_hospitals:"โรงพยาบาลเครือข่าย",
	DR09_Medical_School_03:"แพทยศาสตร์ ดุษฎีบัณฑิต มหาวิทยาลัยเทคนิคแห่งเมืองมิวนิก, สหพันธรัฐเยอรมนี",
	special_clinical_trainnings:"แขนงที่ฝึกฝนเป็นพิเศษ ",
	DR26_Spec:"วิสัญญีวิทยา-อนุสาขาเวชศาสตร์ความปวด",
	DR15_Phramongkutklao:"วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า",
	Exercise_:"การบริหารร่างกาย",
	DR09_Medical_School_02:"วิทยาศาสตรมหาบัณฑิต (การแพทย์คลินิก), ม.มหิดล",
	DR09_Medical_School_01:"แพทยศาสตรบัณฑิต คณะแพทยศาสตร์ ศิริราชพยาบาล ม.มหิดล",
	DR12_Language:"อังกฤษ, ไทย",
	DR19_fellowship:"กระดูกสันหลัง",
	DR25_Lan:"อังกฤษ, ไทย",
	homeLink:"หน้าแรก",
	Specialties:"สาขาวิชาที่เชี่ยวชาญ",
	DR13_Language:"อังกฤษ, ไทย",
	DR11_Special_Clinical_Trainings_03:"โครงการ International Training Course for Full-endoscopic Operations of the Lumbar, Thoracic and Cervical Spine ครั้งที่ 47",
	DR11_Special_Clinical_Trainings_01:"โครงการแลกเปลี่ยนเพื่อศึกษาดูงานต่างประเทศที่ Spinal Injuries Center",
	DR11_Special_Clinical_Trainings_02:"โครงการ Spine University",
	DR19_Neurological:"ประสาทศัลยศาสตร์",
	DR10_Specialties:"ประสาทศัลยศาสตร์",
	DR12_Specialties:"ประสาทศัลยศาสตร์",
	DR10_Medical_School:" โรงพยาบาลรามาธิบดี, มหาวิทยาลัยมหิดล",
	find_doctor:"ค้นหาแพทย์",
	senior_surgeon:"ศัลยแพทย์อาวุโส",
	Pleaseemail:"กรุณาตรวจสอบอีเมลของคุณ",
	DR28_1:"ผศ.นพ. ปรัชญา ปัญญารัตน์",
	HomePrincHospital:"หน้าแรกโรงพยาบาลพริ๊นซ์",
	DR15_Lan:"อังกฤษ, ไทย",
	DR07_Medical_School:"ศิริราชพยาบาล, มหาวิทยาลัยมหิดล",
	DR27_Siriraj:"มหาวิทยาลัยมหิดล",
	DR35_Spec:"วิสัญญีวิทยา",
	DR25_mu:"วิทยาลัยแพทยศาสตร์พระมงกุฎเกล้า",
	DR13_Board_Certification_02:"โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดล",
	I_need_surgery:"ฉันต้องการรักษา",
	next:"ถัดไป",
	timline2013:"2556",
	timline2014:"2557",
	timline2015:"2558",
	timline2016:"2559",
	Im_fine:"ฉันสบายดี",
	submit:"ส่ง",
	timline2010:"2553",
	timline2011:"2554",
	timline2012:"2555",
	Time:"เวลา",
	DR08_Special_Clinical_Interests_01:"การผ่าตัดกระดูกสันหลังด้วยเทคนิคการผ่าตัดแผลเล็ก",
	DR08_Special_Clinical_Interests_02:"การผ่าตัดแก้ไขกระดูกสันหลังผิดรูป",
	lname:"อรุณจรัสธรรม",
	exercise2:"ปวดคอ",
	exercise1:"ปวดหลัง",
	nonSurgery:"ไม่ผ่าตัดรักษา",
	DR15_Diploma:"วุฒิบัตรวิสัญญีวิทยา รพ.พระมงกุฎเกล้า",
	timline2017:"2560",
	timline2018:"2561",
	timline2019:"2562",
	Password:"รหัสผ่าน",
	DR34_Spec:"วิสัญญีวิทยา-อนุสาขาเวชศาสตร์ความปวด",
	HOMEAKC_Hospital:"หน้าแรก AHC Hospital",
	Confirm_password:"ยืนยันรหัสผ่าน",
	Patient:"ข้อมูลคนไข้",
	DR17_position:"วิทยาลัยบูรพา",
	phahonyothin:"พหลโยธิน",
	DR07_Specialties:"O",
	RememberMe:"จดจำฉัน",
	DR09_Specialties:"ประสาทศัลยศาสตร์",
	location:"สถานที่ :",
	rama2:"พระราม",
	ConditionLink:"ภาวะ",
	Location:"ที่ตั้ง",
	timline2009:"2552",
	Account:"บัญชีผู้ใช้งาน",
	selectNonS:"เลือกการไม่ผ่าตัดรักษา",
	DR10:"นพ. วิธวินท์ เกสรศักดิ์",
	DR11:"นพ. ศิรวิชญ์ สุวิทยะศิริ",
	DR12:"นพ. ศิริวุฒิ โภคนันท์",
	DR13:"พญ. ศศิวิมล มงคลสุขไพบูลย์",
	DR14:"พญ. กัณฐิกา วศินพงศ์วณิช",
	DR15:"พญ. วรรณวิภา มาลัยทอง",
	special_clinical_interests:"แขนงที่สนใจเป็นพิเศษ",
	logout:"ออกจากระบบ",
	DR16:"ผศ.นพ. พร้อมพงศ์ อนุชิตชาญชัย",
	DR17:"ผศ.นพ. กิตติ อรุณจรัสธรรม",
	DR18:"นพ. ปโยธร เดชะรินทร์",
	DR19:"นพ. นภทีป์ เสกขพันธุ์",
	ks2004:"2547",
	Login:"เข้าสู่ระบบ",
	ks2008:"2551",
	DR01:"นพ. วีระพันธ์ ควรทรงธรรม",
	DR02:"รศ.นพ. เอก หังสสูต",
	selectS:"เลือกการผ่าตัดรักษา",
	DR03:"นพ. วัฒนา มหัทธนกุล",
	DR04:"รศ.นพ. อัตถพร บุญเกิด",
	DR05:"รศ.พญ. นุช ตันติศิริรนทร์",
	DR06:"น.ท.นพ. อิทธิพล โกมลหิรัณย์",
	DR07:"รศ.นพ. ธเนศ วัฒนะวงษ์",
	DR34_Lan:"อังกฤษ, ไทย",
	DR08:"ผศ.นพ. มนต์ชัย เรืองชัยนิคม",
	DR09:"รศ.นพ. ภัทรวิทย์ รักษ์กุล",
	DR08_Language:"อังกฤษ, ไทย",
	Country:"ประเทศ",
	DR08_Special_Clinical_Trainings_01:"2557 ประกาศนียบัตรการผ่าตัดกระดูกสันหลังผ่านกล้องเอ็นโดสโคป",
	ProcedureLink:"หัตถการ",
	DR08_Special_Clinical_Trainings_02:"2559 ประกาศนียบัตรการผ่าตัดแก้ไขกระดูกสันหลังผิดรูป",
	ks2012:"2555",
	DR08_Special_Clinical_Trainings_03:"2560 ประกาศนียบัตรการผ่าตัดกระดูกสันหลังแผลเล็กผ่านทางหน้าท้อง (Oblique lumbar interbody fusion: OLIF)",
	DR12_Board_Certifications_1:"ประสาทศัลยศาสตร์ ",
	DR08_Special_Clinical_Trainings_04:"2561 ประกาศนียบัตรการผ่าตัดกระดูกสันหลังด้วยหุ่นยนต์ (Robotic Spine Surgery)",
	DR12_Board_Certifications_2:"โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดล",
	DR08_Fellowships_02:"ประกาศนียบัตรสาขาการผ่าตัดกระดูกสันหลังหลักสูตรนานาชาติ จาก University of California, Los Angeles",
	ks2016:"2559",
	ks2013:"2556",
	DR08_Fellowships_01:"ประกาศนียบัตรสาขาการผ่าตัดกระดูกสันหลัง คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล ",
	ks2014:"2557",
	HomeNKT_Hospital:"ศูนย์กระดูกสันหลัง โรงพยาบาลนครธน",
	ks2019:"2562",
	DR32:"นพ. สุวัฒน์ เงาประเสริฐวงศ์",
	board_certifications:"วุฒิบัตร",
	Symptoms_Articles:"อาการ/ บทความ",
	DR34:"นพ. ปัตย์ ปั้นเหน่งเพ็ชร",
	ks2018:"2561",
	DR36:" นพ. ปวินท์ เกษมพิพัฒน์ชัย",
	DR37:"นพ. บดินทร์ วโรดมวนิชกุล",
	DR09_Fellowships:"ผ่าตัดบาดแผลเล็กทางประสาทศัลยศาสตร์ สมองและกระดูกสันหลัง (โรงพยาบาลโบเกนเฮาเซ่นแห่งเมืองมิวนิก สหพันธรัฐเยอรมนี)",
	event:"กิจกรรม",
	DR30_name:"พญ. ปริศนา ปัญญาไวย",
	Book_Appointment:"นัดหมายแพทย์",
	DR14_Lan:"อังกฤษ, ไทย",
	DR23_Spec:"ประสาทศัลยศาสตร์",
	find_view_doctor:"แพทย์",
	DR20:"นพ. รุ่งรัฐ จิตตการ",
	DR21:"นพ. เอกสักถ์ จันทรปรรณิก",
	doctorProfileCard:"ประวัติแพทย์ผู้เชี่ยวชาญ",
	DR22:"นพ. ปริญญา บุณยสนธิกุล",
	DR23:"นพ. สิทธิพงษ์ สุทธิอุดม",
	DR24:"รศ.นพ. รัฐฤกษ์ อรุณากูร",
	DR25:"ผศ.นพ. สิทธาพันธ์ มั่นชูพงศ์",
	DR26:"รศ.พญ. จอมใจ วิจิตรานนท์",
	Senior_consultant:"แพทย์ที่ปรึกษา",
	DR27:"นพ. กิติภัทท์ กฤตยาภิรมย์",
	DR28:"ผศ.นพ.ปรัชญา ปัญญารัตน์",
	DR10_Board_Certifications:"สาขาประสาทศัลยศาสตร์, ประเทศไทย",
	DR29:"นพ. ธีรฉัตต์ ธนะสารสมบูรณ์",
	Team_Concept:"แนวคิด",
	DR25_Sithapan:"ผศ.นพ.สิทธาพันธ์ มั่นชูพงศ์",
	county_type:"ประเทศอังกฤษ",
	Medical_School:"ปริญญาบัตรและสถาบันการศึกษา",
	DR35_Lan:"อังกฤษ, ไทย",
	specialtyH:"สาขาวิชาที่เชี่ยวชาญ",
	DR13_Accomplishment:"การใช้ค่าเฉลี่ยของ apparent diffusion coefficient จากเครื่องเอ็มอาร์ไอในการคาดคะเนความเหนียวของเนื้องอกเยื่อหุ้มสมอง",
	Exercise:"ออกกำลังกาย",
	DR13_Specialties:"ประสาทศัลยศาสตร์",
	Vision_Mission:"วิสัยทัศน์ & พันธกิจ",
	languageMenu:"ภาษา",
	Hospital:"โรงพยาบาล",
	specialtyV:"ศัลยศาสตร์กระดูกและข้อ, ผ่าตัดกระดูกสันหลัง",
	DR22_Neurosurgery:"ประสาทศัลยศาสตร์",
	HomeASCNKT:"หน้าแรก ASC โรงพยาบาลนครธน",
	DR07_Medical_Faculty:"แพทยศาสตรบัณฑิต, ",
	password_incorrect:"รหัสผ่านไม่ถูกต้อง",
	DR08_Medical_School:" คณะแพทยศาสตร์ศิริราชพยาบาล",
	exerciseAfter:"การออกกำลังกายหลังการผ่าตัด",
	DR07_Special_Clinical_Trainings:"การผ่าตัดกระดูกสันหลังด้วยเครื่องคอมพิวเตอร์สามมิติ",
	DR11_Fellowships_02_1:"ประกาศนียบัตรชั้นสูงทางวิทยาศาสตร์การแพทย์คลินิก (ออร์โธปิดิกส์)",
	DR11_Fellowships_02_2:"คณะแพทยศาสตร์ มหาวิทยาลัยขอนแก่น",
	DR13_Medical_Faculty:"แพทยศาสตรบัณฑิต",
	DR20_Lan:"อังกฤษ, ไทย",
	DR10_Medical_Faculty:"แพทยศาสตรบัณฑิต,",
	option:"วันที่นัดหมาย",
	DR29_Lan:"อังกฤษ, ไทย",
	Create_account:"สร้างบัญชีผู้ใช้งาน",
	find_neardoctor:"โรงพยาบาลที่ใกล้คุณ",
	DR21_Spec:"วิสัญญีวิทยา-อนุสาขาเวชศาสตร์ความปวด",
	ASC_Family_Member:"สมาชิกครอบครัว",
	nav_injection:"การรักษาโดยไม่ผ่าตัด",
	founders:"ผู้ก่อตั้ง",
	DR28_Spec:"ประสาทศัลยศาสตร์",
	An_email:"ส่งอีเมลถึงคุณแล้ว",
	DR15_Pain:"อนุสาขาระงับปวด รพ.รามาธิบดี",
	content18:"การผ่าตัดกระดูกสันหลังโดยใช้หุ่นยนต์ช่วยผ่าตัดนำวิถี",
	content19:"การฉีดซีเมนต์เสริมกระดูกด้วยเครื่องคอมพิวเตอร์นำวิถี",
	content14:"โรคช่องกระดูกสันหลังตีบแคบกดทับเส้นประสาท",
	content15:"โรคกระดูกสันหลังคด",
	content16:"หมอนรองกระดูกคอเสื่อม",
	content17:"ปวดหลังร้าวลงขา",
	content10:"การใช้คลื่นความถี่วิทยุเพื่อบำบัดปวดข้อต่อฟาเซ็ต",
	content11:"การฉีดยาเข้าข้อต่อฟาเซ็ตหรือเข้าเส้นประสาทฟาเซ็ต",
	DR31_Spec:"ประสาทศัลยศาสตร์",
	content12:"หัตถการระงับปวดแบบไม่ต้องผ่าตัด",
	content13:"ปวดคอ",
	Service:"บริการ",
	DR11_Fellowships_01_1:"ประกาศนียบัตรแพทย์ผู้เชี่ยวชาญเฉพาะทาง อนุสาขาการผ่าตัดกระดูกสันหลัง",
	HomeASC_Hospital:"หน้าแรก ASC Hospital",
	DR11_Fellowships_01_2:"คณะแพทยศาสตร์ศิริราชพยาบาล มหาวิทยาลัยมหิดล",
	DR07_Special_Clinical_Interests:"ผ่าตัดกระดูกสันหลังด้วยวิธีผ่านกล้อง",
	DR18_Spec:"ประสาทศัลยศาสตร์",
	Testimonial:"จากใจคนไข้",
	our_specaillists:"ทีมแพทย์ผู้เชี่ยวชาญ",
	date_available:"วันที่เร็วสุดที่ทำนัดหมายได้"
});
$translateProvider.translations('en', {
	Appointment:"Appointment",
	DR24_Spec:"Orthopaedics",
	Gender:"Gender",
	SerAbout:"Our Surgeons",
	DR07_Language:"English, Thai",
	DR12_Spine_surgery:"Minimally invasive spine surgery",
	Our_Team:"Our Team",
	ks1996_1998:"1996-1998",
	about_us:"About Us",
	DR10_Language:"English, Thai",
	tel:"Tel:",
	Vistion:"Vision & Mission",
	knowledge:"Knowledge",
	ngamwongwan:"Ngamwongwan",
	DR11_Special_Clinical_Interest_03:"Spinal Oncology",
	Special_Interests:"Special Clinical Interests",
	DR11_Special_Clinical_Interest_02:"Spinal Deformity",
	DR11_Special_Clinical_Interest_01:"Minimally Invasive Spine Surgery",
	packages:"Packages",
	DR28_Lan:"English, Thai",
	Related:"Related",
	Verify_Account:"Verify Account",
	Watch_more:"Watch more",
	DR19_Spec:"Neurosurgery",
	out_team_concept:"Our  Team Concept",
	C2003:"2003",
	DR21_Lan:"English, Thai",
	DR24_kku:"Khon Kaen University",
	find_hospital:"Hospital",
	nav_complete:"Complete",
	close:"Close",
	C2016:"2016",
	C2014:"2014",
	address:"Address:",
	affiliated_hospitals:"AFFILIATED HOSPITALS",
	DR07_Spec:"Orthopaedics",
	nav_sentEmail:"An email has been sent to you.",
	Register:"Register",
	desVideo:"Remark : Actual equipment used may be different, up to the surgeon's decision.",
	DR20_Spec:"Orthopaedics",
	register:"Register",
	DR16_Spec:"Orthopaedics",
	HomeASCAKC:"Home ASC Aikchol",
	Email:"Email",
	DR19_Lan:"English, Thai",
	oldequlnew:"Password must differ from old password",
	HomeASC_ASC:"Home ASC",
	contact:"Contact",
	Procedure:"Procedure",
	DR27_Lan:"English, Thai",
	Resend_code:"Resend code",
	SymptomsLink:"Symptoms",
	preferred_date:"Choose a preferred date",
	DR09_Board_Certifications:"Diplomate, Thai Board of Neurological Surgery",
	DR19_mu:"Mahidol University",
	success:"Successfully",
	Symptoms:"Symptoms",
	Reset_your_password:"Reset your password",
	DR22_Lan:"English, Thai",
	back:"Back",
	warning_emailpass:"Please enter your email or password",
	content9:"Epidural steroid injection",
	duration:"Duration",
	Language:"Language Spoken",
	DR08_Medical_Faculty:"Doctor of Medicine (M.D., first class honor) ",
	New_Password:"New Password",
	Condition:"Condition",
	Submitted:"Submit",
	special_clinical:"Special Clinical Trainings/ Interests",
	Fellowship:"Fellowships",
	Appointment_date:"Appointment date",
	DR37_Lan:"English, Thai",
	HomeAKC_AKC:"Home AHC",
	DR11_Medical_Faculty:" Doctor of Medicine (M.D.) ",
	Review_Appointment_Detail:"ReviewAppointmentDetail",
	DR22_CU:"Chulalongkorn University , Thailand",
	home:"Home",
	content8:"Oblique lumbar interbody fusion",
	content7:"Transforaminal Lumbar Interbody Fusion",
	content6:"Lumbar intervertebral discs herniation",
	content5:"Back pain",
	Follow_Us:"Follow Us",
	content4:"Cervical disc replacement surgery",
	DR11_Board_Certifications_01:"Diploma in Orthopedic Surgery ",
	Special_Trainings:"Special Clinical Trainings",
	content3:"Anterior cervical discectomy and fusion",
	DR22_Med:"Doctor of Medicine,",
	DR27_med:"Doctor of Medicine Faculty of Medicine, ",
	DR11_Board_Certifications_02:"Faculty of Medicine, Khon Kaen University, Khon Kaen, Thailand.",
	content2:"Endoscopic Spine Surgery",
	content1:"Neck pain with arm symptoms",
	DR12_Special_Clinical_Interest_02:"Spine and spinal cord surgery",
	DR15_Spec:"Anesthesiology-Pain Medicine",
	DR07_Board_Certifications:"Diploma of The Thai Board of Orthopaedic Surgery",
	articles:"ARTICLES AND ACTIVITIES",
	DR38_name:"Taweechai Janpen, M.D",
	Board_Certi:"Board Certifications",
	Appointment_Details:"Appointment Details",
	DR18_Lan:"English, Thai",
	education:"Education",
	Birthday:"Birthday",
	DR25_Spec:"Anesthesiology-Pain Medicine",
	DR38_lan:"English,Thai",
	Surgery:"Surgery",
	DR25_rama:"Ramathibodi Hospital",
	desLogin:"Don't have an  account?",
	Current_Password:"Current Password",
	DR15_Rama:"Ramathibodi Hospital",
	Academic_Activity:"Academic Activities",
	Position:"Position",
	DR36_name:"Pawin Kasempipatchai, M.D.",
	HomeAKC_Hospital:"ASC Aikchol Hospital",
	Affiliated_Hospitals:"Affiliated Hospitals",
	DR19_med:"Doctor of Medicine,",
	AD2010:"2010",
	AD2011:"2011",
	AD2012:"2012",
	AD2014:"2014",
	WelcometoSpineBumrungrad:"Welcome to Spine Bumrungrad",
	AD2016:"2016",
	save:"Save",
	AD2018:"2018",
	Confirm:"Confirm",
	AD2019:"2019",
	user_profile:"User Profile",
	DR12_Medical_Faculty:"M.D., Faculty of Medicine,",
	login:"Login",
	nav_checkEmail:"Please check your email.",
	DR31_Lan:"English, Thai",
	DR23_Lan:"English, Thai",
	dr11_2019:"2019",
	dr11_2016:"2016",
	KnowledgeLink:"Knowledge",
	Symptom:"Symptom",
	DR07_Fellowships:"Spine, Ramathibodi Hospital, Mahidol University, Academic Rank: Associate Professor, Ramathibodi Hospital, Mahidol University, Thailand",
	AD2020:"2020",
	Full_name:"Full name",
	nav_surgery:"Surgery",
	Doctor_name:"Doctor’s name",
	specialists:"SPECIALISTS",
	Nationality:"Nationality",
	DR29_Spec:"Orthopaedics",
	ForgotPass:"Forgot password",
	Find_Treatment:"Find Treatment",
	chonburi:"Chon Buri",
	DR32_Spec:"Neurosurgery",
	DR13_Medical_School:"Ramathibodi Hospital, Mahidol University, Thailand",
	Appointment_request_submitted:"Appointment request submitted",
	DR26_Spec_interest:"Special Clinical Trainings/ Interests",
	DR11_Specialties:"Orthopaedics",
	Fellowships:"Fellowships",
	mediical_school:"Medical School",
	Reset:"Reset",
	DR17_Spec:"Orthopaedics",
	DR22_CU_non_t:"จุฬาลงกรณ์มหาวิทยาลัย",
	DR09_Language:"German, English and Thai",
	AD2003:"2003",
	AD2006:"2006",
	AD2007:"2007",
	ks1993:"1993",
	AD2008:"2008",
	City:"City",
	ks1998:"1998",
	DR17_Lan:"English, Thai",
	DR26_Name:"Assoc. Prof. Chomchai Vichitrananda, M.D.",
	DR24_med:"M.D., Faculty of Medicine,",
	accomplisment:"Accomplisment",
	DR12_Accomplishment_02:"Pokanan S, Tuntiyatorn L, Larbchareonsub N, Mongkolsukpaiboon S, Hansasuta A. Can Average Value of Apparent Diffusion Coefficient (ADC) from Magnetic ",
	DR27_Spec:"Neurosurgery",
	Get_start:"Get start",
	DR25_fellow:"Certificate of Clinical Fellowship in Pain Management, ",
	DR22_Spec:"Neurosurgery",
	DR08_Board_Certifications:"Diploma of Thai Board of Orthopaedic Surgery",
	home_bsn:"Bumrungrad Spine Network",
	DR12_Accomplishment_01:"Pokanan S, Borsu H, Hansasuta A. Spinal sac Termination and Internal Filum Terminale Fusion: A Study from 80 cadavers. Clin. Anat.2020;33:558-561",
	DR24_Lan:"English, Thai",
	DR37_Spec:"Neurosurgery",
	HomeASCPrinc:"Home ASC Princ ",
	Accomplishment:"Accomplishment",
	live_your2:"at Absolute Spine Care",
	live_your1:"Live your life to the fullest",
	DR11_Language:"English, Thai",
	Find:"Search",
	Completed:"Completed",
	DR08_Specialties:"Orthopaedics",
	DR15_Phramong:"Phramongkutklao Hospital",
	DR13_Special_Clinical_Interest_02:"Spine and spinal cord surgery",
	position_in_associations:"Position (in associations)",
	Phone_number:"Phone number",
	Make_Appointment:"Make Appointment",
	welcome:"Welcome Back",
	fname:"Dr. Kitti",
	timline2020:"2020 - Present",
	DR32_Lan:"English, Thai",
	DR25_med:"Doctor of Medicine (M.D.) Phramongkutklao College of Medicine,",
	namefull:"Dr. Kitti Aroonjarattham",
	DR11_Medical_School:" Faculty of Medicine Siriraj Hospital, Mahidol University, Bangkok, Thailand.",
	DR38_spec:"Neurosurgery",
	DR15_MU:"Mahidol University",
	Close:"Close",
	DR13_Special_Clinical_Interest_01:"Minimally invasive spine surgery",
	DR16_Lan:"English, Thai",
	DR12_Medical_School:"Chulalongkorn University, Thailand",
	DR16_position:"",
	Forgot_password:"Forgot password",
	readMore:"Read more",
	Im_sick:"I’m sick",
	DR10_Fellowships_02:"AOspine Fellow at Queen’s Medical Centre, Nottingham, United Kingdom",
	DR14_Spec:"Orthopaedics",
	DR13_Board_Certifications_01:"Diploma of The Thai Board of Neurosurgery ",
	DR10_Fellowships_01_1:"Full-Endoscopic spine surgery ",
	DR10_Fellowships_01_2:"with Dr. Sebastian Ruetten at St. Anna-Hospital Herne, Herne, Germany",
	email:"Email:",
	DR15_DoctorofMedicine:"Doctor of Medicine (M.D.)",
	DR25_Diploma:"Diploma of Thai Board of Anesthesiology",
	network_hospitals:"Network Hospitals",
	DR09_Medical_School_03:"Doktor der Medizin, Germany (Munich), Technical University of Munich",
	special_clinical_trainnings:"Special Clinical Trainings",
	DR26_Spec:"Anesthesiology-Pain Medicine",
	DR15_Phramongkutklao:"Phramongkutklao College of Medicine, ",
	Exercise_:"Exercise",
	DR09_Medical_School_02:"MSc (Medical Science)",
	DR09_Medical_School_01:"Doctor of Medicine Faculty of Medicine, Siriraj Hospital, Mahidol University",
	DR12_Language:"English, Thai",
	DR19_fellowship:"Clinical fellowship of Spinal Neurosurgery",
	DR25_Lan:"English, Thai",
	homeLink:"Home",
	Specialties:"Specialties",
	DR13_Language:"English, Thai",
	DR11_Special_Clinical_Trainings_03:"The 47th of International Training Course for Full-endoscopic Operations of the Lumbar, Thoracic and Cervical Spine",
	DR11_Special_Clinical_Trainings_01:"International Fellowship Program at Spinal Injuries Center.",
	DR11_Special_Clinical_Trainings_02:"Spine University Program at Samsung Medical Center",
	DR19_Neurological:"Thai board of Neurological surgery",
	DR10_Specialties:" Neurosurgery",
	DR12_Specialties:"Neurosurgery",
	DR10_Medical_School:" Ramathibodi Hospital, Mahidol University, Thailand",
	find_doctor:"Find Doctor ",
	senior_surgeon:"Senior Surgeons",
	Pleaseemail:"Please check your email.",
	DR28_1:"Assist. Prof. Prachya Punyarat, M.D.",
	HomePrincHospital:"Home Princ Hospital",
	DR15_Lan:"English, Thai",
	DR07_Medical_School:"Siriraj Hospital, Mahidol University, Thailand",
	DR27_Siriraj:"Siriraj Hospital, Mahidol University",
	DR35_Spec:"Anesthesiology",
	DR25_mu:" Mahidol University",
	DR13_Board_Certification_02:"Ramathibodi Hospital Mahidol University",
	I_need_surgery:"I need surgery",
	next:"Next",
	timline2013:"2013",
	timline2014:"2014",
	timline2015:"2015",
	timline2016:"2016",
	Im_fine:"I’m fine",
	submit:"Submit",
	timline2010:"2010",
	timline2011:"2011",
	timline2012:"2012",
	Time:"Time",
	DR08_Special_Clinical_Interests_01:"Minimally invasive Spine Surgery Scoliosis",
	DR08_Special_Clinical_Interests_02:"Spinal deformity correction surgery",
	lname:"Aroonjarattham",
	exercise2:"Neck Pain",
	exercise1:"Back Pain",
	nonSurgery:"Non - Surgery",
	DR15_Diploma:"Diploma of Thai Board of Anesthesiology, ",
	timline2017:"2017",
	timline2018:"2018",
	timline2019:"2019",
	Password:"Password",
	DR34_Spec:"Anesthesiology-Pain Medicine",
	HOMEAKC_Hospital:"Home AHC Hospital",
	Confirm_password:"Confirm password",
	Patient:"Patient's information",
	DR17_position:"",
	phahonyothin:"Phahonyothin",
	DR07_Specialties:"ศัลยศาสตร์กระดูกและข้อ",
	RememberMe:"Remember me",
	DR09_Specialties:"Neurosurgery",
	location:"Location :",
	rama2:"Rama II",
	ConditionLink:"Condition",
	Location:"Location",
	timline2009:"2009",
	Account:"Account",
	selectNonS:"Select Non - Surgery",
	DR10:"Withawin Kesornsak, M.D.",
	DR11:"Siravich Suvithayasiri, M.D.",
	DR12:"Siriwut Pokanan, M.D.",
	DR13:"Sasivimon Mongkolsukpaiboon, M.D.",
	DR14:"Kanthika​ Wasinpongwanich​, M.D.",
	DR15:"Wanwipha Malaithong, M.D.",
	special_clinical_interests:"Special Clinical Interests",
	logout:"Logout",
	DR16:"Assist. Prof. Promtpong Anuchitchanchai, M.D.",
	DR17:"Assist. Prof. Kitti Aroonjarattham, M.D.",
	DR18:"Payothorn Decharin, M.D.",
	DR19:"Noppatee Segkhaphant, M.D.",
	ks2004:"2004",
	Login:"Login",
	ks2008:"2008",
	DR01:"Dr. Verapan Kuansongtham",
	DR02:"Assoc. Prof. Ake Hansasuta",
	selectS:"Select Surgery",
	DR03:"Wattana Mahattanakul",
	DR04:"Assoc. Prof. Atthaporn Boongird",
	DR05:"Assoc. Prof. Nuj Tontisirin",
	DR06:"Ittipol Komonhirun",
	DR07:"Assoc. Prof. Thanet Wattanawong, M.D.",
	DR34_Lan:"English, Thai",
	DR08:"Assist. Prof. Monchai Ruangchainikom, M.D.",
	DR09:"Assoc. Prof. Pataravit Rukskul, M.D.",
	DR08_Language:"English, Thai",
	Country:"Country",
	DR08_Special_Clinical_Trainings_01:"Certificate of 31st International Training course for Full Endoscopic Operations of the Lumbar, Thoracic and Cervical Spine, Spine Institute, Bumrungrad International, Bangkok, Thailand",
	ProcedureLink:"Procedure",
	DR08_Special_Clinical_Trainings_02:"Certificate of Advances in Spinal Deformity: International Symposium  & Cadaveric Workshop, Siriraj  Hospital, Bangkok, Thailand",
	ks2012:"2012",
	DR08_Special_Clinical_Trainings_03:"Certificate of Attendance in Oblique Lateral Training: OLIF 25TM &OLIF 51TM, Siriraj Hospital, Bangkok, Thailand",
	DR12_Board_Certifications_1:"Diploma of The Thai Board of Neurosurgery",
	DR08_Special_Clinical_Trainings_04:"Certificate of Attendance in the Maxor X Robotic Spine Surgery Cadaveric Training Course, SiTEC, Bangkok, Thailand ",
	DR12_Board_Certifications_2:"Ramathibodi Hospital Mahidol University",
	DR08_Fellowships_02:"Certificate of International Spine Fellowship Training Department of Orthopaedic surgery, Faculty of Medicine, University of California, Los Angeles, USA",
	ks2016:"2016",
	ks2013:"2013",
	DR08_Fellowships_01:"Certificate of Fellowship Training in Spine Surgery, Faculty of Medicine Siriraj Hospital, Mahidol University",
	ks2014:"2014",
	HomeNKT_Hospital:"ASC Nakornthon Hospital",
	ks2019:"2019",
	DR32:"Suwat Ngaoprasertwong, M.D.",
	board_certifications:"Board Certifications",
	Symptoms_Articles:"Symptoms/Articles",
	DR34:"Patt Pannangpetch, M.D.",
	ks2018:"2018",
	DR36:"Pawin Kasempipatchai",
	DR37:"Bordin Varodomvanichkul, M.D.",
	DR09_Fellowships:"Fellowship in Neurological Surgery (minimal invasive neurosurgery and spinal surgery), Krankenhaus Muenchen Bogenhausen, Munich, Germany",
	event:"Event",
	DR30_name:"Pritsana Punyawai, M.D.",
	Book_Appointment:"Book Appointment",
	DR14_Lan:"English, Thai",
	DR23_Spec:"Neurosurgery",
	find_view_doctor:"View doctor",
	DR20:"Roongrath Chitragran, M.D.",
	DR21:"Ekasak Chantrapannik, M.D.",
	doctorProfileCard:"DOCTOR PROFILE",
	DR22:"Parinya Bunyasonthikul, M.D.",
	DR23:"Sittipong Suttiudom, M.D.",
	DR24:"Assoc. Prof. Rattalerk Arunakul, M.D.",
	DR25:"Assist. Prof. Sithapan Munjupong, M.D.",
	DR26:"Assoc. Prof. Chomchai Vichitrananda",
	Senior_consultant:"Senior consultant",
	DR27:"Kitipat Kittayapirom​, M.D.",
	DR28:"Assist. Prof. Prachya Punyarat, M.D.",
	DR10_Board_Certifications:"Diploma of the Thai Board of Neurosurgery",
	DR29:"Teerachat Tanasansomboon, M.D.",
	Team_Concept:"Team Concept",
	DR25_Sithapan:"Assist. Prof. Sithapan Munjupong, M.D.",
	county_type:"United kingdom",
	Medical_School:"Medical School",
	DR35_Lan:"English, Thai",
	specialtyH:"Specialty",
	DR13_Accomplishment:"Pokanan S, Tuntiyatorn L, Larbchareonsub N, Mongkolsukpaiboon S, Hansasuta A. Can Average Value of Apparent Diffusion Coefficient (ADC) from Magnetic ",
	Exercise:"Exercise",
	DR13_Specialties:"Neurosurgery",
	Vision_Mission:"Vision & Mission",
	languageMenu:"Language",
	Hospital:"Hospital",
	specialtyV:"Orthopedics, Spine surgery",
	DR22_Neurosurgery:"Diploma of The Thai of ",
	HomeASCNKT:"Home ASC Nakornthon",
	DR07_Medical_Faculty:"M.D., Faculty of Medicine,",
	password_incorrect:"Your password was incorrect",
	DR08_Medical_School:"Faculty of Medicine Siriraj Hospital, Mahidol University",
	exerciseAfter:"Exercise after surgery",
	DR07_Special_Clinical_Trainings:"Certificate for spine surgery under computer Navigation",
	DR11_Fellowships_02_1:"Higher Graduate Diploma in Clinical Medical Science in Orthopedics ",
	DR11_Fellowships_02_2:"Faculty of Medicine, Khon Kaen University, Khon Kaen, Thailand.",
	DR13_Medical_Faculty:"M.D., Faculty of Medicine, ",
	DR20_Lan:"English, Thai",
	DR10_Medical_Faculty:"M.D., Faculty of Medicine,",
	option:"Preferred date and time option",
	DR29_Lan:"English, Thai",
	Create_account:"Create account",
	find_neardoctor:"Hospital near you",
	DR21_Spec:"Anesthesiology-Pain Medicine",
	ASC_Family_Member:"ASC Family Member",
	nav_injection:"Injection",
	founders:"Founders",
	DR28_Spec:"Neurosurgery",
	An_email:"An email has been sent to you.",
	DR15_Pain:"Certificate of Clinical Fellowship in Pain Management, ",
	content18:"Robot-assisted Spine Surgery",
	content19:"Kyphoplasty under O-arm navigation",
	content14:"Lumbar spinal stenosis",
	content15:"Scoliosis",
	content16:"Cervical Disc Herniation / Cervical Spondylosis",
	content17:"Back pain radiating to the leg",
	content10:"Radiofrequency treatment for facet joint pain",
	content11:"Facet joint / facet nerve injection",
	DR31_Spec:"Neurosurgery",
	content12:"Spinal Intervention",
	content13:"Neck Pain",
	Service:"Service",
	DR11_Fellowships_01_1:"Certificate of Clinical Fellowship Training in Spine Surgery ",
	HomeASC_Hospital:"Home ASC Hospital",
	DR11_Fellowships_01_2:"Faculty of Medicine Siriraj Hospital, Mahidol University, Bangkok, Thailand.",
	DR07_Special_Clinical_Interests:"Orthopedics and minimally invasive Spine Surgery",
	DR18_Spec:"Neurosurgery",
	Testimonial:"Testimonial",
	our_specaillists:"Our  Specialists",
	date_available:"Earliest date available"
});
$translateProvider.preferredLanguage('en');
$translateProvider.useLocalStorage();
}]);